import { TYPE_BICAGAME } from "./type";

export const getDataRevenueBicagame = (url) => {
  return {
    type: TYPE_BICAGAME,
    meta: {
      url,
      method: "GET",
    },
  };
};
